import TextField, { TextFieldProps } from "@mui/material/TextField";
import { ChangeEvent, RefObject } from "react";
import { inputCharacterMaxLength } from "../utils/constant";
import { containsOnlyNumbers } from "../utils/helper";

type MpTextFieldProps = TextFieldProps & {
  innerRef?: RefObject<HTMLDivElement>;
  integerOnly?: boolean; // Only allow digits 0-9, no decimals or other characters
};
export default function MpTextField(props: MpTextFieldProps) {
  const { innerRef, onChange, integerOnly = false, ...rest } = props;
  const newProps = {
    ...rest,
    ref: innerRef,
    inputProps: { maxLength: inputCharacterMaxLength, ...props.inputProps },
  };

  const onChangeOnlyNumber = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const value = e.target.value;

    // If integerOnly is true, check for digits only (0-9)
    if (integerOnly) {
      if (value !== "" && !/^\d+$/.test(value)) {
        return;
      }
    } else {
      // Default behavior: allow decimals and formatting
      if (!containsOnlyNumbers(value)) {
        return;
      }
    }

    if (onChange) {
      onChange(e);
    }
  };

  return <TextField {...newProps} onChange={onChangeOnlyNumber} />;
}
